export const validation = [
    v => !!v || 'validation.passwordEmpty',
    v => (v && v.length >= 12) || 'validation.passwordLength',
    v => (v && /[A-Z]/.test(v)) || 'validation.passwordCapitalLetter',
    v => (v && /[a-z]/.test(v)) || 'validation.passwordSmallLetter',
    v => (v && /[!@#$%^&*()_+{}[\]:;<>,.?~\\/-\d]/.test(v)) || 'validation.passwordSpecialCharacterAndNumber',
];

export default function localizePasswordValidation(localization) {
  return validation.map(rule => v => {
    const result = rule(v);
    if (result === true) {
      return result;
    }
    return localization(result);
  });
}
